/**
 * Client Theme Registry
 * Central registry mapping client IDs to theme overrides
 */

import { defaultThemeOverrides } from './default.tokens';
import { bpThemeOverrides } from './bp.tokens';
import { edpThemeOverrides } from './edp.tokens';
import { shellThemeOverrides } from './shell.tokens';
import { repsolThemeOverrides } from './repsol.tokens';
import { gashogarThemeOverrides } from './gashogar.tokens';
import { pavillionThemeOverrides } from './pavillion.tokens';
import { disaThemeOverrides } from './disa.tokens';
import { energreenThemeOverrides } from './energreen.tokens';
import { luzyThemeOverrides } from './luzy.tokens';
import type { ClientThemeOverrides } from '../utils/themeAugmentation';

/**
 * Registry of all client theme overrides
 * Maps client ID to theme configuration
 */
export const clientThemeRegistry = {
  default: defaultThemeOverrides,
  localhost: defaultThemeOverrides,
  bp: bpThemeOverrides,
  edp: edpThemeOverrides,
  shell: shellThemeOverrides,
  repsol: repsolThemeOverrides,
  gashogar: gashogarThemeOverrides,
  pavillion: pavillionThemeOverrides,
  disa: disaThemeOverrides,
  energreen: energreenThemeOverrides,
  luzy: luzyThemeOverrides,
} as const satisfies Record<string, ClientThemeOverrides>;

/**
 * Type-safe client ID union
 */
export type ClientId = keyof typeof clientThemeRegistry;
